import React, { useState } from 'react';

// Pick the order that will ride on a bag already out with a rider. Only orders with no pack
// (today's, still unpacked) are offered; the rider hands the unsold pieces on to it after the
// customer it follows. Whether it can still be added is the rider backend's call, and its
// answer (the bag must be on the bike, the order the last stop, five at most) comes back as a
// sentence in the page's error banner.
export default function AddBoltOnDialog({ job, candidates, busy, onCancel, onConfirm }) {
  const [pickedId, setPickedId] = useState('');
  const [link, setLink] = useState('');
  const picked = candidates.find(row => row.appointment_id === pickedId);
  const needsLink = picked && !(picked.google_maps_link || '').trim();
  const name = job.customer_name || job.zcp_appointment_uid;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900/45 px-4"
      onClick={onCancel}
    >
      <div
        className="max-h-[90vh] w-full max-w-[560px] overflow-y-auto rounded-lg bg-white px-6 py-5 shadow-2xl"
        onClick={event => event.stopPropagation()}
      >
        <h3 className="text-lg font-bold text-gray-900">Add a bolt-on to {name}&rsquo;s bag</h3>
        <p className="mt-1 text-[13px] leading-5 text-gray-500">
          The rider keeps the bag and gets one more stop. After {name}, they hand what was not
          bought on to this customer, so it fits only if the sizes and gender match.
        </p>

        <div className="mt-4 text-sm font-semibold text-gray-800">Orders with no pack yet</div>
        {candidates.length === 0 ? (
          <div className="mt-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-4 text-sm text-gray-500">
            No unpacked order for today.
          </div>
        ) : (
          <div className="mt-2 space-y-2">
            {candidates.map(row => (
              <label
                key={row.appointment_id}
                className={`flex cursor-pointer gap-2.5 rounded-md border px-3 py-2.5 ${
                  pickedId === row.appointment_id ? 'border-gray-800 bg-gray-50' : 'border-gray-200'
                }`}
              >
                <input
                  type="radio"
                  name="bolt-on"
                  checked={pickedId === row.appointment_id}
                  onChange={() => setPickedId(row.appointment_id)}
                  className="mt-1"
                />
                <span className="min-w-0">
                  <span className="block text-sm font-semibold text-gray-800">
                    {row.customer_name || row.zcp_appointment_uid}
                    <span className="ml-2 text-xs font-normal text-gray-500">
                      {row.scheduled_time} · {row.area}
                    </span>
                  </span>
                  <span className="mt-1 flex flex-wrap gap-1">
                    {(row.children || []).map((child, index) => (
                      <span
                        key={child.appointment_child_id || index}
                        className="rounded-md bg-gray-100 px-1.5 py-0.5 text-[11px] font-medium text-gray-600"
                      >
                        {child.gender ? child.gender.charAt(0).toUpperCase() + child.gender.slice(1) : 'Child'} {child.size || ''}
                      </span>
                    ))}
                  </span>
                </span>
              </label>
            ))}
          </div>
        )}

        {needsLink && (
          <div className="mt-3">
            <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-gray-500">
              Google Maps link for {picked.customer_name || 'this customer'}
            </label>
            <input
              value={link}
              onChange={event => setLink(event.target.value)}
              placeholder="https://maps.app.goo.gl/…"
              className="w-full rounded-md border border-gray-200 px-3 py-2 text-sm focus:border-zoddle-green focus:outline-none"
            />
          </div>
        )}

        <div className="mt-4 flex justify-end gap-2">
          <button
            onClick={onCancel}
            disabled={busy}
            className="rounded border border-gray-300 px-3.5 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50 disabled:opacity-40"
          >
            Cancel
          </button>
          <button
            onClick={() => onConfirm(job, picked, link)}
            disabled={busy || !picked || (needsLink && !link.trim())}
            className="rounded bg-gray-900 px-3.5 py-2 text-sm font-semibold text-white hover:bg-gray-800 disabled:opacity-40"
          >
            {busy ? 'Adding...' : 'Add bolt-on'}
          </button>
        </div>
      </div>
    </div>
  );
}
